import { Participant, Room } from 'livekit-client';
import { getParticipantUserIdFromMetadata } from 'useCase/participant/useParticipantMetadata';

/**
 * Находит участника по userId в комнате
 * @param room - LiveKit room
 * @param userId - User ID участника
 * @returns Participant или null если не найден
 */
export const findParticipantByUserId = (room: Room, userId: string): Participant | null => {
    if (!userId) return null;

    // проверяем локального участника
    const localUserId = getParticipantUserIdFromMetadata(room.localParticipant.metadata);
    if (localUserId === userId) {
        return room.localParticipant;
    }

    // ищем среди удаленных участников
    for (const remoteParticipant of room.remoteParticipants.values()) {
        const participantUserId = getParticipantUserIdFromMetadata(remoteParticipant.metadata);
        if (participantUserId === userId) {
            return remoteParticipant;
        }
    }

    return null;
};
